import React, {useState, useEffect, useRef, useMemo} from 'react';
import {cssClasses} from '../shared/utils';
import {BaseToggles, SimpleToggles, AsteriskToggles} from "../shared/toggles";

function * colourIndex(coloured, paletteSize = 16) {
	if (!coloured) {
		while (true) {
			yield 1;
		}
	} else {
		let i = 0;
		while (true) {
			yield (i++ % paletteSize) + 1;
		}
	}
}

function usePopup(initial) {
	let [shown, setShown] = useState(initial);
	let ref = useRef(null);
	let container = ref.current;
	useEffect(() => {
		if (shown && container) {
			let handler = (e) => {
				if (!container.contains(e.target)) {
					setShown(false);
				}
			};
			window.addEventListener('click', handler);
			return () => window.removeEventListener('click', handler);
		}
	});
	return [ref, shown, setShown];
}

function Toggles(props) {
	const {
		initialValue, options, className, onChange,
		coloured = false, paletteSize = 16
	} = props;

	const [toggles, setToggles] = useState(() => {
		let toggles;
		if (!(options instanceof BaseToggles)) {
			toggles = new SimpleToggles(options);
		} else {
			toggles = options;
		}
		if (initialValue) {
			let iv = initialValue;
			if (!Array.isArray(iv)) {
				iv = [iv];
			}
			toggles.allOff();
			for (let v of iv) {
				toggles.toggleOn(v);
			}
		}
		return toggles;
	});

	const [container, shown, setShown] = usePopup(false);
	const items = useMemo(() => {
		const onClick = function (item) {
			let c = toggles.clone();
			c.toggle(item);
			if (onChange instanceof Function) {
				onChange(c);
			}
			setToggles(c);
		};
		const items = [];
		const ci = colourIndex(coloured, paletteSize);
		for (let t of toggles.items.values()) {
			let c = cssClasses(
				'cm-item cm-toggle', t.isOn ? 'cm-on' : 'cm-off',
				`zl-text-ci-${ci.next().value}`);
			items.push(
				<div
					key={t.key} className={c}
					onClick={() => onClick(t)}>
					<div className="cm-title">{t.value || t.key}</div>
				</div>
			);
		}
		return items;
	}, [toggles, onChange]);

	const values = useMemo(() => {
		return toggles.formatValues();
	}, [toggles]);

	return (
		<div
			ref={container}
			className={cssClasses('cm-toggles cm-checkboxes cm-popup', className)}
		>
			<a
				href="#" className="cm-content-info"
				onClick={
					(e) => {
						e.preventDefault();
						setShown(!shown);
					}
				}
			>
				{values}
			</a>
			<div className={cssClasses('cm-items', {collapse: !shown})}>
				{items}
			</div>
		</div>
	);
}

export default Toggles;
export {
	BaseToggles as BaseTogglesCl,
	SimpleToggles as SimpleTogglesCl,
	AsteriskToggles as AsteriskTogglesCl
};